module.exports = __webpack_public_path__ + "img/20240701.5ae88c3f.png";